import { Button, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  file: File | null;
  onChange: (newFile: File) => void;
  label?: string;
  description?: string;
  accept?: string;
}

export default function FileUploader({ file, onChange, label, description, accept }: Props) {
  const intl = useIntl();

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Button variant="contained" color="primary" component="label">
          {label || intl.formatMessage({ defaultMessage: 'Upload File' })}
          <input type="file" hidden accept={accept} onChange={(e) => e.target.files?.length && onChange(e.target.files[0])} />
        </Button>
        <Typography>{file?.name ? file.name : intl.formatMessage({ defaultMessage: 'No file chosen' })}</Typography>
      </Stack>
      {description && <Typography>{description}</Typography>}
    </Stack>
  );
}
